const limpar_titulo = (title) => {
    if(title==null) return "";
    title = title.replace('ONLINE - ', '');
    title = title.replace('[ONLINE]', '');
    title = title.replace('[2020.1]', '');
    title = title.replace('[2019.1]', '');
    title = title.replace('[GRATUITO]', '');
    title = title.replace('[COMBO]', '');
    title = title.replace('[CICLO DE MENTORIA]', '');
    title = title.replace('[POWER HACKS]', '');
    title = title.replace('[MASTER CLASS]', '');
    title = title.replace('[LETS GROW]', '');
    title = title.replace('AULA AO VIVO - ', '');
    title = title.replace('[DESMISTIFICANDO]', '');
    title = title.replace('[WORKSHOP]', '');
    title = title.replace(' TRUQUES DE EXCEL PARA PROCESSOS SELETIVOS -', '');
    title = title.replace(' MARKETING DIGITAL - ', '');
    title = title.replace(' MARKETING DE CONTEÚDO - ', '');
    title = title.replace(' BLACK BELT NA PRÁTICA - ', '');
    title = title.replace(' SCRUM PARA GERENCIAMENTO DE PROJETOS - ', '');
    title = title.replace(' INOVAÇÃO E DESIGN THINKING - ', '');
    title = title.replace(' GESTÃO FINANCEIRA - ', '');
    title = title.replace('[MUNDO EMPREENDEDOR] ', '');
    title = title.replace('[PAPO DE CONSULTOR] ', '');
    title = title.replace('[PAPO DE ESPECIALISTA] ', '');
    title = title.replace('[PASSO A PASSO] ', '');
    title = title.replace('[SOFT SKILLS] ', '');
    title = title.replace('[INDÚSTRIA 4.0] ', '');
    title = title.split('(');
    title = title[0];
    return title;
}

export default limpar_titulo;